import { render, staticRenderFns } from "./GenericDownload.vue?vue&type=template&id=6d425d4e"
import script from "./GenericDownload.vue?vue&type=script&lang=js"
export * from "./GenericDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports